import { render, staticRenderFns } from "./vids.vue?vue&type=template&id=4177c83d&scoped=true&"
import script from "./vids.vue?vue&type=script&lang=js&"
export * from "./vids.vue?vue&type=script&lang=js&"
import style0 from "./vids.vue?vue&type=style&index=0&id=4177c83d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4177c83d",
  null
  
)

export default component.exports